import React, { useState } from 'react';

const AuthField = ({
  id,
  label,
  type = 'text',
  name,
  value,
  onChange,
  placeholder,
  required,
  autoComplete,
  icon = 'envelope'
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === 'password';
  const inputType = isPassword && showPassword ? 'text' : type;

  const iconClass =
    icon === 'lock'
      ? 'fa-lock'
      : icon === 'user'
        ? 'fa-user'
        : icon === 'phone'
          ? 'fa-phone'
          : 'fa-envelope';

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-semibold text-gray-900 mb-2">
        {label}
      </label>
      <div className="relative">
        <span className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400">
          <i className={`fas ${iconClass} text-sm`} aria-hidden />
        </span>
        <input
          id={id}
          type={inputType}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          autoComplete={autoComplete}
          placeholder={placeholder}
          className="w-full pl-10 pr-10 py-3 text-sm text-gray-900 placeholder:text-gray-400 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-900/10 focus:border-gray-400 transition-colors"
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} text-sm`} />
          </button>
        )}
      </div>
    </div>
  );
};

export default AuthField;
